import { Table } from '@tanstack/react-table'

import { Log, FilterType, DailyLogCode, MileageLossCode } from '@/types/logs'
import { compareValueWithPrefix, extractParts } from '@/helpers/compareValueWithPrefix'

const dailyLogCodes: string[] = Object.values(DailyLogCode)

export const formatRunFilterValues = (
    values: string[],
    table: Table<Log>,
    filter: FilterType = FilterType.All
): string[] => {
    const availableRuns: string[] = table.getCoreRowModel().rows.reduce<string[]>((acc, row) => {
        if (!row.original.run) {
            return acc
        }

        if (filter === FilterType.DailyLog && dailyLogCodes.includes(row.original.code)) {
            acc.push(row.original.run)
        }

        if (filter === FilterType.MileageLoss && row.original.code in MileageLossCode) {
            acc.push(row.original.run)
        }

        if (filter === FilterType.All) {
            acc.push(row.original.run)
        }

        return acc
    }, [])

    const filteredValues = values.reduce<string[]>(
        (acc, run) => (availableRuns.includes(run) ? [...acc, run] : acc),
        []
    )

    return filteredValues.sort((a, b) => {
        const [prefixA, numA, suffixA] = extractParts(a)
        const [prefixB, numB, suffixB] = extractParts(b)

        return compareValueWithPrefix([prefixA, numA, suffixA], [prefixB, numB, suffixB])
    })
}
